import React from 'react';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const NonNavFooter = () => {
	return (
    <AppBar position="static" sx={{ backgroundColor: "#163133" }}>
      <Container style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "2rem" }}>
        <div style={{ flex: 1 }}>
          <a href="https://jeonsoft.com" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: "none" }}>
            <img src="/images/JSlogo.png" alt="" style={{ width: "10rem" }} />
          </a>
          <Typography sx={{ color: "#FFFFFF", marginTop: "1rem" }}>
            Main Office: 37/F LKG Tower 6801 Ayala Ave. Makati City <br/> Operation Office: 564 Quirino Highway, Novaliches, Quezon City
          </Typography>
        </div>
        <div style={{ flex: 1, textAlign: "right" }}>
          <Typography sx={{ color: "#FFFFFF", padding: "0 0.3rem" }}>
            Follow us on
          </Typography>
          <a href="https://www.facebook.com/jeonsoftcorp/" target="_blank" rel="noopener noreferrer">
            <FacebookIcon sx={{ fontSize: "2rem", color: "#FFFFFF" }} />
          </a>
          <a href="https://twitter.com/jeonsoftcorp/" target="_blank" rel="noopener noreferrer">
            <TwitterIcon sx={{ fontSize: "2rem", color: "#FFFFFF" }} />
          </a>
          <a href="https://www.linkedin.com/company/jeonsoft-corporation/" target="_blank" rel="noopener noreferrer">
            <LinkedInIcon sx={{ fontSize: "2rem", color: "#FFFFFF" }} />
          </a>
          <a href="https://jeonsoft.com/#" target="_blank" rel="noopener noreferrer">
            <EmailIcon sx={{ fontSize: "2rem", color: "#FFFFFF" }} />
          </a>
        </div>
      </Container>
    </AppBar>
  );
}

export default NonNavFooter;